import * as React from "react";

import { Link } from "react-router-dom";

const WIB_PORTAL_URL = process.env.WIB_PORTAL_URL;

export default function UnauthorizedPage() {
  return (
    <div className="container">
      <div className="row mt-5">
        <div className="col text-center">
          <h4>
            You do not have the required permissions to access this workspace
          </h4>
          <p>
            Please navigate back to the user <a href={WIB_PORTAL_URL}>portal</a>{" "}
            or <Link to="/auth/logout">sign out</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
